import { NavLink } from 'react-router-dom';
import { useProject } from '../contexts/ProjectContext';
import { authService } from '../services/auth';

const projectLinks = (evalEnabled) => {
  const links = [
    { to: '/', label: 'Home' },
    { to: '/routing/', label: 'Routing' },
  ];
  if (evalEnabled) links.push({ to: '/evals/', label: 'Evals' });
  links.push(
    { to: '/history/', label: 'History' },
    { to: '/playground/', label: 'Playground' },
  );
  return links;
};

const accountLinks = [
  { to: '/settings/', label: 'Settings' },
  { to: '/billing/', label: 'Billing' },
  { to: '/docs/', label: 'Docs' },
];

export default function Sidebar() {
  const { projects, selectedHash, setSelectedProject, selectedProject } = useProject();
  const links = projectLinks(selectedProject?.eval_enabled);

  const logout = () => {
    authService.logout();
    window.location.assign('/login/');
  };

  return (
    <aside className="w-56 shrink-0 h-full bg-theme-secondary p-4 border-r border-theme-secondary flex flex-col">
      <div className="text-xl font-semibold text-theme-primary mb-6">os-router</div>

      <label className="text-xs opacity-60 mb-1">Project</label>
      <select
        value={selectedHash || ''}
        onChange={(e) => setSelectedProject(e.target.value)}
        className="mb-6 w-full rounded-lg border border-theme-secondary bg-theme-main px-2 py-2 text-sm"
      >
        {projects.map((p) => (
          <option key={p.hash} value={p.hash}>{p.name}</option>
        ))}
      </select>

      <nav className="flex flex-col gap-1">
        {links.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            end={link.to === '/'}
            className={({ isActive }) =>
              `px-3 py-2 rounded-lg text-sm ${isActive ? 'bg-theme-main text-theme-primary' : 'text-theme-text opacity-80 hover:opacity-100'}`
            }
          >
            {link.label}
          </NavLink>
        ))}
      </nav>

      <div className="mt-auto pt-6 border-t border-theme-secondary/60 flex flex-col gap-1">
        {accountLinks.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            className={({ isActive }) =>
              `px-3 py-2 rounded-lg text-sm ${isActive ? 'bg-theme-main text-theme-primary' : 'text-theme-text opacity-80 hover:opacity-100'}`
            }
          >
            {link.label}
          </NavLink>
        ))}
        <button
          type="button"
          onClick={logout}
          className="px-3 py-2 rounded-lg text-sm text-left text-theme-text opacity-80 hover:opacity-100 hover:text-red-400 transition-colors"
        >
          Log out
        </button>
      </div>
    </aside>
  );
}
